import { Component, OnInit, EventEmitter, Input, Output, OnDestroy } from '@angular/core';
import { CastingMode } from '../../att-casting-view.component';

export type CastingLinkDisplayMode = 'label' | 'url' | 'both';
export type CastingLinkValue = {
	base: string;
	display: CastingLinkDisplayMode;
	label: string;
}
@Component({
	selector: 'app-casting-link',
	templateUrl: './casting-link.component.html',
	styleUrls: ['./casting-link.component.scss']
})
export class CastingLinkComponent implements OnInit, OnDestroy {
	private _base = '';
	private _label = 'view link';
	private _display: CastingLinkDisplayMode = 'label';
	private _settingValue = true;
	private _destroyed = false;

	public set base(val: string) {
		if (this._destroyed === true) {
			return;
		}
		this._base = val;
		if (this._settingValue === false) {
			this.Update();
		}
	}
	public get base(): string {
		return this._base;
	}
	public set label(val: string) {
		if (this._destroyed === true) {
			return;
		}
		this._label = val;
		if (this._settingValue === false) {
			this.Update();
		}
	}
	public get label(): string {
		return this._label;
	}
	public set display(val: CastingLinkDisplayMode) {
		if (this._destroyed === true) {
			return;
		}
		this._display = val;
		if (this._settingValue === false) {
			this.Update();
		}
	}
	public get display(): CastingLinkDisplayMode {
		return this._display;
	}

	@Input()
	public castingMode:CastingMode = 'entry';
	@Input('value')
	public set value(val: CastingLinkValue) {
		if (this._destroyed === true) {
			return;
		}
		this._settingValue = true;
		this.base = val.base;
		this.display = val.display;
		this.label = val.label;
		this._settingValue = false;

	}

	public get value(): CastingLinkValue {
		return {
			base: this.base,
			display: this.display,
			label: this.label
		}
	}
	@Output()
	public valueChange = new EventEmitter<CastingLinkValue>();

	constructor() { }

	ngOnInit(): void {
		this.Update();
	}
	Update() {
		this.valueChange.emit(this.value);
	}
	ngOnDestroy(): void {
		this._destroyed = true;
	}

}
